angular.module('app.usuario', [
  'ui.router',
  'toastr',
  'app.usuarioService',
  'app.parametrizacionService'
])

  .config(
    ['$stateProvider', '$urlRouterProvider',
      function ($stateProvider, $urlRouterProvider) {
        $stateProvider
          .state('index.usuario', {

            abstract: true,

            url: 'usuarios',

            params: {

            },

            views: {
              '': {
                templateUrl: 'app/usuario/usuario.tpl.html',
                resolve:
                  {

                  },
                controller: ['$scope', '$state', 'toastr',
                  function ($scope, $state, toastr) {



                  }]
              }
            }

          })
          .state('index.usuario.bandeja', {

            url: '',

            views: {
              '': {
                templateUrl: 'app/usuario/usuario.bandeja.tpl.html',
                resolve: {
                  dataCargos: ['usuarioService',
                    function (usuarioService) {
                      return usuarioService.getCargo();
                    }],
                  dataEstudios: ['usuarioService',
                  function (usuarioService) {
                    return usuarioService.getEstudio();
                  }]
                  },
                controller: ['$scope', '$state', 'usuarioService', 'toastr', 'ngDialog', 'authService', 'dataCargos', 'parametrizacionService','dataEstudios',
                  function ($scope, $state, usuarioService, toastr, ngDialog, authService, dataCargos, parametrizacionService, dataEstudios) {
                    $scope.editar_usuario = false;
                    edicion_cargo = false;
                    agregar_centro = false;

                    getDespachos = function()
                    {
                      parametrizacionService.getDespachos(-1,-1, $scope.CONSTANTES.COMPETENCIA).then( 
                        function ( response ) {
                            $scope.dataDespachos = [];
                            $scope.dataDespachos = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                    }

                    $scope.cargos = [];
                    $scope.cargos = dataCargos.data;
                    $scope.estudios = [];
                    $scope.estudios = dataEstudios.data;
                    $scope.getUsuariosSistema = function()
                    {
                      usuarioService.getUsuariosSistema().then(
                        function ( response ) 
                        {
                          $scope.usuarios = [];
                          $scope.usuarios = response.data;
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                    }
                    $scope.getUsuariosSistema();                    

                    buscarUsuarioExistente = function(valor, arreglo){
                      for (var i=0; i < arreglo.length; i++) {
                          if (arreglo[i].USUARIO === valor) {
                              return true;
                          }
                      }
                      return false;
                    }

                    viewGestionUsuario = function (usuario) {
                      $scope.dialogShowUsuario = ngDialog.open({
                        template: 'app/usuario/usuario.gestionar.tpl.html',
                        showClose: true,
                        closeByEscape: true,
                        preCloseCallback:function()
                        {
                          $scope.getUsuariosSistema();

                        },
                        className: 'ngdialog-theme-flat-custom custom-width',
                        scope: $scope,
                        controller: ['$scope',
                          function ($scope) {
                            $scope.usuarioInterno = {};
                            $scope.usuarioInterno.ESTADO_BUZON = "BUZÓN INACTIVO";
                            $scope.buzon_tooltip = "Activar buzón";
                            $scope.mostrar_boton_buzon = $scope.CONSTANTES.REGISTRO_VERDADERO;
                            $scope.usuarioInterno.BUZON_ARCHIVOS = $scope.CONSTANTES.NO_MOSTRAR_BUZON_ARCHIVO;
                            $scope.MOSTRAR_BOTON_ELIMINAR_USUARIO = false;
                            if ($scope.editar_usuario == true)
                            {
                              $scope.MOSTRAR_BOTON_ELIMINAR_USUARIO = true;
                            }
                            getDespachosUsuario = function(p_id_usuario)
                            {
                              usuarioService.getDespachosUsuario(p_id_usuario, $scope.CONSTANTES.REGISTRO_VERDADERO).then(
                                function (response)
                                {
                                  $scope.centrosUsuario = [];
                                  $scope.centrosUsuario = response.data;
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                });
                            }

                            getDespachosUsuario = function(p_id_usuario)
                            {
                              usuarioService.getDespachosUsuario(p_id_usuario, $scope.CONSTANTES.REGISTRO_VERDADERO).then(
                                function (response)
                                {
                                  $scope.centrosUsuario = [];
                                  $scope.centrosUsuario = response.data;
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                });
                            }

                            getDespachosAsignarUsuario = function(p_id_usuario)
                            {
                              usuarioService.getDespachosUsuario(p_id_usuario, 2).then(
                                function (response)
                                {
                                  $scope.dataDespachos = [];
                                  $scope.dataDespachos = response.data;
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                });
                            }

                            if ($scope.editar_usuario  == false)
                            {
                              $scope.descripcion_formulario_usuario = "Nuevo usuario";
                            }
                            else
                            {
                              $scope.descripcion_formulario_usuario = "Edición usuario";
                              angular.copy(usuario,$scope.usuarioInterno);
                              getDespachosUsuario(usuario.ID_USUARIO);  
                              getDespachosAsignarUsuario(usuario.ID_USUARIO);
                            }

                            $scope.buscarUsuario = function(isValid)
                            {
                              if (isValid)
                              {
                                usuarioService.getPersonaUsuarioInterno($scope.usuarioInterno.USUARIO).then(
                                  function ( response ) 
                                    {
                                      if (response.data.id == -1)
                                      {
                                        toastr.error(response.data.msj);  
                                        // $scope.mostrarDatosUsuario=false;
                                        // $scope.mostrarFotoUsuario = false;
                                      }
                                      else
                                      {
                                        $scope.MOSTRAR_NOMBRE = false;
                                        /*if (verificarFirma)
                                        {
                                          $scope.MOSTRAR_NOMBRE = true;
                                          $scope.usuarioInterno.ESTADO_FIRMA = "USUARIO SIN FIRMA";
                                          $scope.usuarioInterno.FIRMA_DOCUMENTO = response.data.TIENE_FIRMA;
                                          $scope.mostrar_boton_buzon = $scope.CONSTANTES.REGISTRO_FALSO;
                                          if (response.data.TIENE_FIRMA == $scope.CONSTANTES.USUARIO_CON_FIRMA)
                                          {
                                            $scope.usuarioInterno.ESTADO_FIRMA = "USUARIO CON FIRMA";
                                            $scope.mostrar_boton_buzon = $scope.CONSTANTES.REGISTRO_VERDADERO;
                                          }
                                        }
                                        else */
                                        if (buscarUsuarioExistente(response.data.SAU_CUENTA,$scope.usuarios))
                                        {
                                          toastr.warning("Usuario ya registrado");  
                                        }
                                        else
                                        {
                                          $scope.MOSTRAR_NOMBRE = true;
                                          $scope.usuarioInterno.USUARIO = response.data.SAU_CUENTA;
                                          $scope.usuarioInterno.NOMBRE = response.data.NOMBRE_COMPLETO;
                                          $scope.usuarioInterno.ID_USUARIO = response.data.EMPLEADO_ID;
                                          $scope.usuarioInterno.CORREO = response.data.SAU_CORREO;
                                          $scope.usuarioInterno.ESTADO_FIRMA = "USUARIO SIN FIRMA";
                                          $scope.usuarioInterno.FIRMA_DOCUMENTO = response.data.TIENE_FIRMA;
                                          $scope.mostrar_boton_buzon = $scope.CONSTANTES.REGISTRO_VERDADERO;
                                          $scope.usuarioInterno.ESTADO_BUZON = "BUZÓN INACTIVO";
                                          $scope.buzon_tooltip = "Activar buzón";
                                          $scope.usuarioInterno.BUZON_ARCHIVOS = $scope.CONSTANTES.NO_MOSTRAR_BUZON_ARCHIVO;
                                          if (response.data.TIENE_FIRMA == $scope.CONSTANTES.USUARIO_CON_FIRMA)
                                          {
                                            $scope.usuarioInterno.ESTADO_FIRMA = "USUARIO CON FIRMA";
                                          }
                                        }
                                        
                                        //$scope.usuarioInterno.DEPENDENCIA = response.data.DEPENDENCIA_NOMBRE;
                                        //$scope.usuarioInterno.FOTO = response.data.FOTO;
                                        //$scope.mostrarDatosUsuario = true;
                                        // if ($scope.usuarioInterno.FOTO != "")
                                        // {
                                        //   $scope.mostrarFotoUsuario = true;
                                        // }
                                        // else
                                        // {
                                        //   $scope.mostrarFotoUsuario = false;
                                        // }
                                        // $scope.mostrarBoton = !$scope.mostrarBoton;
                                        
                                      }
                                    },
                                  function ( error ) 
                                  {
                                    toastr.error( error );
                                    // $scope.mostrarDatosUsuario=false;
                                    // $scope.mostrarFotoUsuario = false;
                                  });
                              }
                              else
                              {
                                toastr.warning("Faltan datos por ingresar");
                              }
                            }

                            $scope.inhabilitarFirma = function()
                            {
                              $scope.usuarioInterno.ESTADO_FIRMA = "FIRMA USUARIO INHABILITADA";
                              $scope.usuarioInterno.FIRMA_DOCUMENTO = $scope.CONSTANTES.FIRMA_USUARIO_INACTIVA; 
                              $scope.mostrar_boton_buzon = $scope.CONSTANTES.REGISTRO_FALSO;
                              $scope.usuarioInterno.ESTADO_BUZON = "BUZÓN INACTIVO";
                            }

                            $scope.cambiarEstadoBuzon = function()
                            {
                              if ($scope.usuarioInterno.BUZON_ARCHIVOS == $scope.CONSTANTES.MOSTRAR_BUZON_ARCHIVO)
                              {
                                $scope.usuarioInterno.BUZON_ARCHIVOS = $scope.CONSTANTES.NO_MOSTRAR_BUZON_ARCHIVO;
                                $scope.usuarioInterno.ESTADO_BUZON = "BUZÓN INACTIVO";
                                $scope.buzon_tooltip = "Activar buzón";
                              }
                              else if ($scope.usuarioInterno.BUZON_ARCHIVOS == $scope.CONSTANTES.NO_MOSTRAR_BUZON_ARCHIVO)
                              {
                                $scope.usuarioInterno.BUZON_ARCHIVOS = $scope.CONSTANTES.MOSTRAR_BUZON_ARCHIVO;
                                $scope.usuarioInterno.ESTADO_BUZON = "BUZÓN ACTIVO";
                                $scope.buzon_tooltip = "Inactivar buzón";
                              }
                            }

                            $scope.editarCargo = function(item)
                            {
                              if (item.isSelected = true)
                              {
                                $scope.MOSTRAR_COMBO_CARGOS = true;
                                $scope.MOSTRAR_COMBO_CENTROS = false;
                                $scope.MOSTRAR_COMBO_ESTUDIOS = false;
                                $scope.MOSTRAR_TABLA_CARGO = false;
                                $scope.MOSTRAR_TABLA_CENTROS = false;
                                $scope.MOSTRAR_BOTON_GUARDAR = true;
                                $scope.MOSTRAR_BOTON_AGREGAR = false;
                                $scope.MOSTRAR_BOTON_ELIMINAR = false;
                                $scope.MOSTRAR_BOTON_ELIMINAR_USUARIO = false;
                                $scope.MOSTRAR_BOTON_LIMPIAR = true;
                                edicion_cargo = true;
                                agregar_centro = true;
                              }
                              else
                              {
                                $scope.limpiar();
                              }
                            }

                            $scope.limpiar = function()
                            {
                              $scope.MOSTRAR_COMBO_CARGOS = false;
                              $scope.MOSTRAR_COMBO_CENTROS = false;
                              $scope.MOSTRAR_COMBO_ESTUDIOS = false;
                              $scope.MOSTRAR_TABLA_CARGO = true;
                              $scope.MOSTRAR_TABLA_CENTROS = true;
                              $scope.MOSTRAR_BOTON_GUARDAR = false;
                              $scope.MOSTRAR_BOTON_AGREGAR = true;
                              $scope.MOSTRAR_BOTON_ELIMINAR = false;
                              $scope.MOSTRAR_BOTON_ELIMINAR_USUARIO = false;
                              if ($scope.editar_usuario == true)
                              {
                                $scope.MOSTRAR_BOTON_ELIMINAR_USUARIO = true;
                              }  
                              $scope.MOSTRAR_BOTON_LIMPIAR = false;
                              edicion_cargo = false;
                              agregar_centro = false;
                              $scope.usuarioInterno.ID_CENTRO_USUARIO = "";
                              getDespachosUsuario(usuario.ID_USUARIO); 
                              getDespachosAsignarUsuario(usuario.ID_USUARIO); 
                            }

                            $scope.editarCentro = function(item)
                            {
                              if (item.isSelected = true)
                              {
                                $scope.MOSTRAR_COMBO_CARGOS = false;
                                $scope.MOSTRAR_COMBO_CENTROS = false;
                                $scope.MOSTRAR_COMBO_ESTUDIOS = false;
                                $scope.MOSTRAR_TABLA_CARGO = false;
                                $scope.MOSTRAR_TABLA_CENTROS = true;
                                $scope.MOSTRAR_BOTON_GUARDAR = false;
                                $scope.MOSTRAR_BOTON_AGREGAR = false;
                                $scope.MOSTRAR_BOTON_ELIMINAR = true;
                                $scope.MOSTRAR_BOTON_ELIMINAR_USUARIO = false;
                                $scope.MOSTRAR_BOTON_LIMPIAR = true;
                                $scope.usuarioInterno.ID_CENTRO_USUARIO = item.ID_CENTRO_USUARIO;
                              }
                              else
                              {
                                $scope.limpiar();
                              }
                            }

                            $scope.eliminarCentro = function()
                            {
                              usuarioService.delCentroUsuario($scope.usuarioInterno).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    toastr.success(response.data.msj);
                                    $scope.limpiar();
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                });
                            }

                            $scope.agregarCentro = function()
                            {
                                $scope.MOSTRAR_COMBO_CARGOS = false;
                                $scope.MOSTRAR_COMBO_CENTROS = true;
                                $scope.MOSTRAR_COMBO_ESTUDIOS = false;
                                $scope.MOSTRAR_TABLA_CARGO = false;
                                $scope.MOSTRAR_TABLA_CENTROS = false;
                                $scope.MOSTRAR_BOTON_GUARDAR = true;
                                $scope.MOSTRAR_BOTON_AGREGAR = false;
                                $scope.MOSTRAR_BOTON_ELIMINAR = false;
                                $scope.MOSTRAR_BOTON_ELIMINAR_USUARIO = false;
                                $scope.MOSTRAR_BOTON_LIMPIAR = true;
                                agregar_centro = true;
                            }

                            $scope.selectedCargo = function(item)
                            {
                              cargo_local = item.CARGO;
                            }

                            $scope.guardarUsuario = function(isValid)
                            {
                              if (isValid)
                              {
                                if ($scope.editar_usuario == false)
                                {
                                  usuarioService.insUsuario($scope.usuarioInterno).then(
                                    function (response)
                                    {
                                      if(response.data.result=='OK')
                                      {
                                        toastr.success(response.data.msj);
                                        //$scope.getUsuariosSistema(); 
                                        $scope.usuarioInterno = {};
                                      }
                                      else
                                      {
                                        toastr.error(response.data.msj);
                                      }                      
                                    },
                                    function (error) 
                                    {
                                      toastr.error( error );
                                    });
                                }
                                if ($scope.editar_usuario == true)
                                {
                                  if (edicion_cargo == true)
                                  {
                                    usuarioService.edtCargoUsuario($scope.usuarioInterno).then(
                                      function (response)
                                      {
                                        if(response.data.result=='OK')
                                        {
                                          toastr.success(response.data.msj);
                                          $scope.usuarioInterno.CARGO = cargo_local;
                                          $scope.limpiar();
                                        }
                                        else
                                        {
                                          toastr.error(response.data.msj);
                                        }                      
                                      },
                                      function (error) 
                                      {
                                        toastr.error( error );
                                      });
                                  }
                                  else if (agregar_centro == true)
                                  {
                                    usuarioService.insCentroUsuario($scope.usuarioInterno).then(
                                      function (response)
                                      {
                                        if(response.data.result=='OK')
                                        {
                                          toastr.success(response.data.msj);
                                          $scope.limpiar();
                                        }
                                        else
                                        {
                                          toastr.error(response.data.msj);
                                        }                      
                                      },
                                      function (error) 
                                      {
                                        toastr.error( error );
                                      });
                                  }
                                }  
                              }
                              else
                              {
                                toastr.warning("Faltan datos por ingresar");
                              }                              

                            }

                          }]
                        });

                        eliminarUsuario = function(item)
                        {
                          usuarioService.delUsuario(item).then(
                            function (response)
                            {
                              if(response.data.result=='OK')
                              {
                                toastr.success(response.data.msj);
                                ngDialog.close($scope.dialogShowSwalEliminarUsuario.id);
                                ngDialog.close($scope.dialogShowUsuario.id);
                                $scope.limpiar();
                              }
                              else
                              {
                                toastr.error(response.data.msj);
                              }                      
                            },
                            function (error) 
                            {
                              toastr.error( error );
                            });
                        }

                        $scope.viewSwalEliminarUsuario = function(item)
                        {
                          $scope.dialogShowSwalEliminarUsuario = ngDialog.open(
                          {
                            template: 'app/casos/casos.seguimiento.swalContainer.view.tpl.html',
                            showClose: false,
                            closeByEscape: false,
                            closeByNavigation: true,
                            preCloseCallback:function()
                            {
                              // $scope.sesion = {};
                              // getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                              // $scope.habilitar_datos_identificacion();
                              // $scope.nuevo_sujeto = false;
                            },
                            className: 'ngdialog-theme-flat-custom',
                            // resolve:
                            // {
                            // },
                            scope:$scope,
                            controller: ['$scope',
                            function($scope) 
                            { 
                              swal({
                                title:'¿Eliminar usuario(a)', 
                                html: ',',
                                text: item.ID_USUARIO+' - '+item.NOMBRE+' ('+item.USUARIO+')',
                                type: "error",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "Continuar",
                                cancelButtonClass: "btn-default",
                                cancelButtonText: "Cancelar",
                                closeOnConfirm: false,
                                closeOnCancel: false }, 
                                function(isConfirm){ 
                                if (isConfirm) 
                                {
                                  swal.close();
                                  $scope.$apply();
                                  eliminarUsuario(item);
                                } 
                                else 
                                {
                                  swal.close();
                                  $scope.$apply();
                                  ngDialog.close($scope.dialogShowSwalEliminarUsuario.id);
                                }
                              });
                              
                            }]
                          })
                        }

                      }
                    
                    $scope.editarUsuario = function(item)
                    {
                      $scope.editar_usuario = true;
                      $scope.MOSTRAR_NOMBRE = true;
                      $scope.MOSTRAR_COMBO_CARGOS = false;
                      $scope.MOSTRAR_COMBO_CENTROS = false;
                      $scope.MOSTRAR_COMBO_ESTUDIOS = false;
                      $scope.MOSTRAR_TABLA_CARGO = true;
                      $scope.MOSTRAR_TABLA_CENTROS = true;
                      $scope.MOSTRAR_BOTON_GUARDAR = false;
                      $scope.MOSTRAR_BOTON_AGREGAR = true;
                      $scope.MOSTRAR_BOTON_ELIMINAR = false;
                      $scope.MOSTRAR_BOTON_ELIMINAR_USUARIO = false;
                      $scope.MOSTRAR_BOTON_LIMPIAR = false;
                      viewGestionUsuario(item);
                    }
                            /*
                            $scope.usuario = {};
                            $scope.delegacion = {};
                            $scope.usuario = dataUsuario.data;
                            $scope.delegaciones = {};
                            $scope.delegaciones = dataDelegaciones.data;

                            usuarioService.getDelegacionUsuario(usuario)
                              .then(function (response) {
                                $scope.delegacion.ID_DELEGACION = response.data.msj;
                              }, function (error) {
                                toastr.error(error);
                              });


                            // $scope.selectedUsuario = function (item) {
                            //   $scope.usuario.ID_USUARIO = item.ID_USUARIO;
                            //   $scope.usuario.NOMBRE = item.NOMBRE;
                            //   $scope.usuario.FOTO = item.FOTO;
                            //   $scope.usuario.ID_ESTADO = item.ID_ESTADO;
                            //   usuarioService.getDelegacionUsuario(item.ID_USUARIO)
                            //     .then(function (response) {
                            //       $scope.delegacion.ID_DELEGACION = response.data.msj;
                            //     }, function (error) {
                            //       toastr.error(error);
                            //     });
                            // }

                            $scope.asignarDelegacion = function () {
                              $scope.delegacion.ID_USUARIO = $scope.usuario.ID_USUARIO;
                              usuarioService.asignarDelegacion($scope.delegacion)
                                .then(function (response) {
                                  if (angular.equals(response.data.result, "OK")) {
                                    swal("Delegacion Asignada", '', "info");
                                  }
                                }, function (error) {
                                  toastr.error(error);
                                });
                            }

                            $scope.desactivarUsuario = function () {
                              $scope.delegacion.ID_USUARIO = $scope.usuario.ID_USUARIO;
                              $scope.delegacion.ID_SISTEMA = $scope.constantes.SISTEMA;
                              $scope.delegacion.ID_USUARIO_REGISTRO = authService.getIdUsuario();
                              usuarioService.desactivarUsuario($scope.delegacion)
                                .then(function (response) {
                                  if (angular.equals(response.data.result, "OK")) {
                                    usuarioService.desactivarUsuarioCAPE($scope.delegacion)
                                      .then(function (response) {
                                        if (angular.equals(response.data.result, "OK")) {
                                        swal("Usuario Desactivado", '', "info");
                                        $scope.usuario.ID_ESTADO = $scope.constantes.ESTADO_INACTIVO
                                        }
                                      }, function (error) {
                                        toastr.error(error);
                                      });
                                  }
                                }, function (error) {
                                  toastr.error(error);
                                });
                            }

                            $scope.reactivarUsuario = function () {
                              $scope.delegacion.ID_USUARIO = $scope.usuario.ID_USUARIO;
                              $scope.delegacion.ID_SISTEMA = $scope.constantes.SISTEMA;
                              $scope.delegacion.ID_USUARIO_REGISTRO = authService.getIdUsuario();
                              usuarioService.reactivarUsuario($scope.delegacion)
                                .then(function (response) {
                                  usuarioService.reactivarUsuarioCAPE($scope.delegacion)
                                      .then(function (response) {
                                        if (angular.equals(response.data.result, "OK")) {
                                        swal("Usuario Reactivado", '', "info");
                                        $scope.usuario.ID_ESTADO = $scope.constantes.ESTADO_ACTIVO
                                        }
                                      }, function (error) {
                                        toastr.error(error);
                                      });
                                }, function (error) {
                                  toastr.error(error);
                                });
                            }



                          }],
                        preCloseCallback: function (value) {

                          usuarioService.getUsuariosActivos()
                            .then(function (response) {
                              $scope.dataUsuarios = response.data;
                            }, function (error) {
                              toastr.error(error);
                            });


                          return true;
                        }
                      });
                    }
*/

                      $scope.agregarUsuario = function()
                      {
                        $scope.editar_usuario = false;
                        $scope.MOSTRAR_NOMBRE = false;
                        $scope.MOSTRAR_COMBO_CARGOS = true;
                        $scope.MOSTRAR_COMBO_CENTROS = true;
                        $scope.MOSTRAR_COMBO_ESTUDIOS = true;
                        $scope.MOSTRAR_TABLA_CARGO = false;
                        $scope.MOSTRAR_TABLA_CENTROS = false;
                        $scope.MOSTRAR_BOTON_GUARDAR = true;
                        $scope.MOSTRAR_BOTON_AGREGAR = false;
                        $scope.MOSTRAR_BOTON_ELIMINAR = false;
                        $scope.MOSTRAR_BOTON_ELIMINAR_USUARIO = false;
                        $scope.MOSTRAR_BOTON_LIMPIAR = false;
                        getDespachos();
                        viewGestionUsuario();
                      }
                  }]
              }
            }
          })
      }
    ]
  );